import { useContext } from 'react';
import { FormFieldContext } from './formFieldContext';
import type { FormFieldVariant } from './formField.types';

export function useFormFieldVariant(fieldVariant?: FormFieldVariant): FormFieldVariant {
  const context = useContext(FormFieldContext);
  return fieldVariant ?? context.variant;
}
